import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../common/Checkbox";
import Style from "style-it";
import SearchField from "../common/SearchField";
import Scrollbar from "react-scrollbars-custom";
import instance from "../../axios";
import isEqual from "react-fast-compare";

class CitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: {},
      search: "",
      isChecked: false,
      cities: { data: [], total: 0 },
      isLoading: false,
    };
  }

  componentDidMount() {
    this.initSelected();
    this.loadCities();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search !== this.state.search) {
      this.loadCities();
    }

    if (!isEqual(prevProps.value, this.props.value)) {
      this.initSelected();
    }

    if (
      this.usesPropCities() &&
      (!isEqual(prevProps.cities, this.props.cities) ||
        !isEqual(prevProps.userCities, this.props.userCities) ||
        !isEqual(prevProps.allowedCities, this.props.allowedCities))
    ) {
      this.loadCities();
    }
  }

  componentWillUnmount() {
    this.setState({
      list: {},
      search: "",
      isChecked: false,
      cities: { data: [], total: 0 },
    });
  }

  /** Logged-in user cities matched against all cities (or explicit allowedCities). */
  getFilteredCities = () => {
    if (
      Array.isArray(this.props.allowedCities) &&
      this.props.allowedCities.length
    ) {
      return this.props.allowedCities;
    }

    const { cities, userCities } = this.props;
    if (userCities?.length && cities?.length) {
      const allIds = new Set(cities.map((c) => c.id));
      return userCities.filter((c) => allIds.has(c.id));
    }
    if (userCities?.length) return userCities;
    return cities || [];
  };

  usesPropCities = () =>
    Boolean(
      (this.props.allowedCities && this.props.allowedCities.length) ||
      this.props.filterByUserCities,
    );

  initSelected = () => {
    const selectedIds = (this.props.value || []).map((id) => String(id));
    const list = {};

    selectedIds.forEach((id) => {
      list[id] = true;
    });

    this.setState({
      list,
      isChecked:
        this.state.cities?.data?.length > 0 &&
        this.state.cities.data.length === selectedIds.length,
    });
  };

  applyLocalCities = () => {
    const search = (this.state.search || "").toLowerCase().trim();
    let data = this.getFilteredCities().map((item) => ({
      ...item,
      cityEn: item.cityEn || item.name || item.label || item.region || "",
      name: item.name || item.cityEn || item.label || item.region || "",
      label: item.label || item.cityEn || item.name || item.region || "",
    }));

    if (search) {
      data = data.filter(
        (c) =>
          String(c.cityEn || "")
            .toLowerCase()
            .includes(search) ||
          String(c.name || "")
            .toLowerCase()
            .includes(search) ||
          String(c.label || "")
            .toLowerCase()
            .includes(search),
      );
    }

    // Selected cities first
    const selected = this.props.value || [];
    const selectedSet = new Set(selected.map((id) => String(id)));
    data = [...data].sort((a, b) => {
      const aSel = selectedSet.has(String(a.id)) ? 0 : 1;
      const bSel = selectedSet.has(String(b.id)) ? 0 : 1;
      return aSel - bSel;
    });

    this.setState(
      {
        cities: { data, total: data.length },
        isLoading: false,
      },
      () => {
        const total = data.length;
        const selectedCount = Object.keys(this.state.list).length;
        this.setState({
          isChecked: total > 0 && total === selectedCount,
        });
      },
    );
  };

  loadCities = () => {
    if (this.usesPropCities()) {
      this.applyLocalCities();
      return;
    }

    this.getCities();
  };

  getCities = () => {
    const userId = this.props.userId || this.props.logInUser?.id;
    if (!userId) return;

    const url = `api/citys/get?limit=-1&search=${this.state.search}`;

    this.setState({ isLoading: true });

    instance
      .get(url)
      .then((res) => {
        const response = res || res;
        let data = response?.data || [];

        const selected = this.props.value || [];
        const selectedSet = new Set(selected.map((id) => String(id)));
        data = [...data].sort((a, b) => {
          const aSel = selectedSet.has(String(a.id)) ? 0 : 1;
          const bSel = selectedSet.has(String(b.id)) ? 0 : 1;
          return aSel - bSel;
        });

        this.setState(
          {
            cities: { ...response, data, total: data.length },
            isLoading: false,
          },
          () => {
            const total = data.length;
            const selectedCount = Object.keys(this.state.list).length;
            this.setState({
              isChecked: total > 0 && total === selectedCount,
            });
          },
        );
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  onChange = (e, city) => {
    let list = { ...this.state.list };
    const id = String(city.id);

    if (e.target.checked) {
      list[id] = true;
    } else {
      delete list[id];
    }

    this.setState(
      {
        list,
        isChecked: this.state.cities?.data?.length === Object.keys(list).length,
      },
      () => {
        this.props.onChange &&
          this.props.onChange(
            Object.keys(this.state.list).map((k) =>
              Number.isNaN(Number(k)) ? k : Number(k),
            ),
            "city",
          );
      },
    );
  };

  toggleItems = (e) => {
    if (e.target.checked) {
      const list = {};
      this.state.cities?.data?.forEach((c) => {
        list[String(c.id)] = true;
      });

      this.setState(
        { list, isChecked: true },
        () =>
          this.props.onChange &&
          this.props.onChange(
            Object.keys(list).map((k) =>
              Number.isNaN(Number(k)) ? k : Number(k),
            ),
            "city",
          ),
      );
    } else {
      this.setState(
        { list: {}, isChecked: false },
        () => this.props.onChange && this.props.onChange([], "city"),
      );
    }
  };

  searchItem = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    return (
      <Style>
        {`
          .selector-list li {
              margin-bottom: 6px;
          }
          .selector-list li > label {
              cursor: pointer;
              display: flex;
              align-items: center;
              padding: 2px 6px;
              border-radius: 4px;
          }
          .selector-list {
              padding: 0;
              margin: 0;
              list-style: none;
          }
          .selector-label {
              font-size: 12px;
              margin-left: 6px;
          }
          .selector-check {
              height: 26px;
              display: inline-flex;
              align-items: center;
          }
          .selector-count {
              padding: 5px 0;
              font-size: 12px;
          }
        `}
        <div>
          <div
            style={{
              marginBottom: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ flex: 0.65, marginRight: 10 }}>
              <SearchField
                label="Search Cities"
                type="search"
                placeholder="Search by name"
                value={this.state.search}
                onChange={this.searchItem}
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </div>
            <div style={{ flex: 0.35 }}>
              <Checkbox
                checked={this.state.isChecked}
                onChange={this.toggleItems}
                label="Select All"
              />
            </div>
          </div>

          <div className="selector-count">
            {Object.keys(this.state.list).length} Cities Selected
          </div>

          <Scrollbar style={{ height: 35 * (this.props.rows || 8) }}>
            {this.state.isLoading ? (
              <h3>Loading...</h3>
            ) : this.state.cities?.data?.length ? (
              <ul className="selector-list">
                {this.state.cities.data.map((row) => (
                  <li key={row.id} style={{ padding: "0px 4px" }}>
                    <label
                      className={
                        this.state.list[String(row.id)] ? "active" : ""
                      }
                    >
                      <span className="selector-check">
                        <Checkbox
                          checked={!!this.state.list[String(row.id)]}
                          onChange={(e) => this.onChange(e, row)}
                        />
                      </span>
                      <span className="selector-label">
                        {row.cityEn || row.name || row.label}
                      </span>
                    </label>
                  </li>
                ))}
              </ul>
            ) : (
              <div>No Cities Found</div>
            )}
          </Scrollbar>
        </div>
      </Style>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
  cities: state.Cities.cities,
  userCities: state.Cities.userCities,
});

export default connect(mapState)(CitySelector);
